<template>
	<TutorialStep
		v-if="isTutorialHighlightingUI && currentOffer"
		:type="TutorialStepTypes.ARROW"
		:relativeAlignment="'left'"
	>
		<template #default>
			<div
				v-if="currentOffer"
				class="ad-box"
				:class="`ad-${typeIcon}-60`"
				@click="handleAdClick"
			>
				<AppMainIcon :iconName="IconTypes.PLAY_AD" :iconSize="18" />
			</div>
		</template>
	</TutorialStep>
	<div
		v-else-if="currentOffer"
		class="ad-box"
		:class="`ad-${typeIcon}-60`"
		@click="handleAdClick"
	>
		<AppMainIcon :iconName="IconTypes.PLAY_AD" :iconSize="18" />
	</div>
</template>

<script lang="ts" setup>
import AppMainIcon from "@/components/AppMainIcon.vue";
import TutorialStep from "@/components/TutorialStep.vue";
import { useEventStore } from "@/event";
import useOfferStore from "@/store/useOfferStore";
import { usePopupStore } from "@/store/usePopupStore";
import useQuestStore from "@/store/useQuestStore";
import useRuntimeStore from "@/store/useRuntimeStore";
import { IconTypes, TutorialStepTypes } from "@/types/ui";
import { storeToRefs } from "pinia";
import { computed, onMounted, onUnmounted, watch } from "vue";
const questStore = useQuestStore();
const { isTutorialHighlightingUI } = storeToRefs(questStore);

const offerStore = useOfferStore();
const { currentOffer } = storeToRefs(offerStore);

const runtimeStore = useRuntimeStore();
const { superClickerInitialized } = storeToRefs(runtimeStore);

const eventStore = useEventStore();

const popupStore = usePopupStore();

let checkInterval: ReturnType<typeof setInterval> | null = null;

onMounted((): void => {
	// Check for offers every 30 seconds
	checkInterval = setInterval((): void => {
		offerStore.checkAndShowOffer();
	}, 30 * 1_000);
});

onUnmounted((): void => {
	if (checkInterval) {
		clearInterval(checkInterval);
	}
});

const typeIcon = computed((): string => {
	if (currentOffer.value?.type === "eventium") {
		return `${eventStore.attributes.type}-eventium`;
	}
	return currentOffer.value?.type ?? "";
});

const handleAdClick = (): void => {
	if (currentOffer.value) {
		if (isTutorialHighlightingUI.value) {
			popupStore.hidePopup();
			questStore.setIsTutorialHighlightingUI(false);
		}
		// Show popup with ad details
		offerStore.setVisibility(true);
	}
};

watch(
	(): boolean => superClickerInitialized.value,
	(value: boolean): void => {
		if (value) {
			offerStore.checkAndShowOffer();
		}
	},
);
</script>

<style lang="scss" scoped>
.ad-box {
	position: relative;
	@include clickable-element;
	margin-left: 0.5rem;

	:deep(.icon) {
		position: absolute;
		bottom: 0.094rem;
		left: 50%;
		transform: translateX(-50%);
		filter: drop-shadow(0.044rem 0.044rem 0.063rem rgba(0, 0, 0, 0.6));
	}
}
</style>
